import { SECTION_DESCRIPTIONS } from '@communities/content-management/utils/sectionDescriptions';
import { Text, Heading, Dialog } from '@soteria/design-system-ve';

import * as styles from './MoreInfoDialog.css';

interface TopicsMoreInfoDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export function TopicsMoreInfoDialog({ isOpen, onClose }: TopicsMoreInfoDialogProps) {
  return (
    <Dialog cancelAction={{ label: 'Close' }} isOpen={isOpen} size="xxxl" title={SECTION_DESCRIPTIONS.TOPICS.title} onClose={onClose}>
      <div className={styles.dialogContent}>
        <Text>
          Topics are content categories that help you organize and manage different types of user-generated content in your community. They act as
          organizational containers that allow you to apply specific rules and processes to different kinds of content.
        </Text>

        <div className={styles.section}>
          <Heading level="h3">Key benefits:</Heading>
          <ul className={styles.list}>
            <li className={styles.listItem}>
              <Text>Apply specific moderation rules to different content types</Text>
            </li>
            <li className={styles.listItem}>
              <Text>Organize content for better discoverability</Text>
            </li>
            <li className={styles.listItem}>
              <Text>Streamline moderation workflows with targeted approaches</Text>
            </li>
          </ul>
        </div>

        <Text>
          Use topics to separate player communications, user uploads, and community discussions, ensuring the right moderation approach is applied to each
          content type.
        </Text>
      </div>
    </Dialog>
  );
}
